import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import "./Resetpassword.css";

const Resetpassword = () => {
  const [email, setEmail] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();

    if (!email) {
      enqueueSnackbar("Please enter your email.", { variant: "warning" });
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      enqueueSnackbar("Password reset email sent!", {
        variant: "success",
        autoHideDuration: 3000, // make sure snackbar shows long enough
      });

      // Delay navigation so user sees the snackbar
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        enqueueSnackbar("This email is not registered. Please check and try again.", {
          variant: "error",
        });
      } else {
        enqueueSnackbar("Something went wrong. Please try again later.", {
          variant: "error",
        });
      }
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-card">
        <h2>Reset Password</h2>
        <p>Enter your registered email to receive reset instructions.</p>
        <form onSubmit={handleReset}>
          <input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit">Send Reset Link</button>
        </form>
        <p className="back-login" onClick={() => navigate("/login")}>
          Back to Login
        </p>
      </div>
    </div>
  );
};

export default Resetpassword;
